import { render, staticRenderFns } from "./SopimusTallenna.vue?vue&type=template&id=6d0b2016&scoped=true&"
import script from "./SopimusTallenna.vue?vue&type=script&lang=js&"
export * from "./SopimusTallenna.vue?vue&type=script&lang=js&"
import style0 from "./SopimusTallenna.vue?vue&type=style&index=0&id=6d0b2016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0b2016",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VIcon,VRow,VToolbar,VToolbarTitle,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0b2016')) {
      api.createRecord('6d0b2016', component.options)
    } else {
      api.reload('6d0b2016', component.options)
    }
    module.hot.accept("./SopimusTallenna.vue?vue&type=template&id=6d0b2016&scoped=true&", function () {
      api.rerender('6d0b2016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SopimusTallenna.vue"
export default component.exports